import { lazy } from 'react';

export const AdminMissionRingProofPage = lazy(() => import('./admin-mission-ring-proof-page'));
